<template>
  <div>
    <v-card class="my-1">
      <v-card-title>EA Form</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="selectedYear"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Year"
            :items="years"
            clearable
            hide-selected
            :error-messages="errors.collect('selectedYear')"
            data-vv-name="selectedYear"  
            data-vv-as="year"
          />
          <v-autocomplete
            v-model="selectedCompanies"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Companies"
            item-text="name"
            item-value="id"
            :items="companies"
            clearable
            multiple
            hide-selected 
            chips
            small-chips
            deletable-chips
            :error-messages="errors.collect('selectedCompanies')"
            data-vv-name="selectedCompanies"  
            data-vv-as="companies"
          />
        </v-col>
  
        <v-col
          cols="12"
          class="ma-auto"
        >      
          <v-row class="text-center">
            <v-col cols="12">
              <payroll-report-ea-form-release
                class="mb-2"
                :loading="loading"
                :selected-year="selectedYear"
                :selected-companies="selectedCompanies"
                :employees="employees"
                :companies="companies"
              />
              <payroll-report-ea-form-generate
                class="mb-2"
                :loading="loading"
                :selected-year="selectedYear"
                :selected-companies="selectedCompanies"
                :employees="employees"
                :companies="companies"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    components: {
      PayrollReportEaFormRelease: () => import('@/components/hris/payroll/report/EaFormRelease'),
      PayrollReportEaFormGenerate: () => import('@/components/hris/payroll/report/EaFormGenerate'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        companies: [],
        selectedCompanies: [],
        dropdownLoading: false,
        selectedYear: 0,
        years: [],
        employees: [],
      }
    },
    computed: {
      computedFilter () {
        if (this.selectedCompanies.length < 1 || !this.selectedYear) return
        return `${this.selectedCompanies}|${this.selectedYear}`
      },    
    },
    watch: {
      computedFilter: {
        immediate: true,
        handler (newVal) {
          if (newVal) {
            const [newCompanies, newSelecteYear] = newVal.split('|')       
            if (newCompanies !== null && newSelecteYear !== null) {
              this.fetchEaEmployees()
            }
          }
        },
      },
    },       
    created () {
      this.dropdownLoading = true

      this.$api.hrisCompanies().list()
        .then(res => {
          this.companies = _.orderBy(res.data, ['name'], ['asc'])

          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.dropdownLoading = false
        })

      this.$api.payrollPeriods().list('?year=distinct')
        .then(res => {
          this.years = res.data
        })
    },
    methods: {
      prepareFormData () {
        return {
          year: this.selectedYear,
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies }
      },
      fetchEaEmployees () {
        this.employees = []
                
        this.$api.payrollReports().listEaEmployees(this.prepareFormData())
          .then(res => {
            if (res.data.length > 0) {
              res.data.map(data => {
                this.employeeObj = {
                  company_employee_uid: data.companyEmployee.company_employee_uid,
                  company_uid: data.companyEmployee.company.id,
                  name: data.companyEmployee.employee.person.name,
                  company_name: data.companyEmployee.company.name,
                  start_date: data.companyEmployee.start_date,
                  end_date: data.companyEmployee.end_date,
                }
                this.employees.push(this.employeeObj)

                this.employees = _.orderBy(this.employees, ['name', 'start_date'], ['asc', 'desc'])

                this.employees = this.employees.filter((e, i) => {
                  return this.employees.findIndex((x) => {
                    return x.name === e.name && x.company_uid === e.company_uid && (x.end_date && e.end_date === this.$moment(x.start_date).add(1, 'days') ? e.end_date === this.$moment(x.start_date).add(1, 'days') : x.end_date ? x.end_date : x.end_date === null)
                  }) === i
                })
              })
            } else {
              this.$snack({ 
                color: 'error',
                message: 'No Records Found', 
              })              
            }
          })    
      },
    },
  }
</script>
